<div *ngIf="isOpen" class="modal-backdrop fixed inset-0 bg-black/50 flex items-center justify-center p-4"
  [style.z-index]="backdropZIndex"
  (click)="$event.stopPropagation()">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden relative">
    <!-- Full overlay for processing to ensure visible progress -->
    <div *ngIf="isProcessing" class="absolute inset-0 bg-white/70 backdrop-blur-sm z-50 flex items-center justify-center">
      <div class="flex flex-col items-center gap-3">
        <i class="fas fa-spinner fa-spin text-3xl text-[var(--primary)]"></i>
        <div class="text-sm font-semibold text-[var(--primary)]">Preparing print preview…</div>
      </div>
    </div>
    <!-- Header (theme primary color) -->
    <div class="flex items-center gap-3 px-5 py-4 bg-[var(--primary)]">
      <div class="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
        <i [class]="iconClass + ' text-white text-xl'"></i>
      </div>
      <h3 class="text-white text-lg font-semibold tracking-tight">{{ title }}</h3>
    </div>

    <!-- Body -->
    <div class="p-6">
      <p class="text-slate-800 text-base font-semibold leading-relaxed">{{ message }}</p>
    </div>

    <!-- Processing indicator -->
    <div *ngIf="isProcessing" class="flex items-center gap-3 px-6 py-3 bg-yellow-50 border-t border-yellow-100">
      <i class="fas fa-spinner fa-spin text-yellow-600"></i>
      <span class="text-sm text-yellow-800 font-medium">Preparing print preview — please wait...</span>
    </div>

    <!-- Footer: type="button" so these never submit a parent form (e.g. Provider modal). -->
    <div class="flex items-center justify-end gap-3 px-6 py-4 bg-slate-50">
      <button type="button" *ngIf="showCancel" [disabled]="isProcessing" class="px-4 py-2 rounded text-sm text-slate-700 border border-transparent hover:bg-slate-100 disabled:opacity-60"
        (click)="onCancel()">Cancel</button>
      <button type="button" *ngIf="showNo" [disabled]="isProcessing" class="px-4 py-2 rounded text-sm bg-white border border-slate-300 hover:bg-slate-100 disabled:opacity-60"
        (click)="onNo()">
        <i *ngIf="isProcessing" class="fas fa-spinner fa-spin mr-2 text-slate-500"></i>
        {{ noLabel }}
      </button>
      <button type="button" [disabled]="isProcessing" class="px-4 py-2 rounded text-sm bg-[var(--primary)] text-white hover:opacity-95 disabled:opacity-70"
        (click)="onYes()">
        <i *ngIf="isProcessing" class="fas fa-spinner fa-spin mr-2 text-white"></i>
        {{ primaryLabel }}
      </button>
    </div>
  </div>
</div>

